import clsx from 'clsx';
import { ReactNode } from 'react';

import cn from './style.module.sass';
type CommonTitleProps = {
    children: ReactNode;
    className?: string;
};

export default function CommonTitle({ children, className = '' }: CommonTitleProps) {
    return <h2 className={clsx(`${cn['common__title']} ${className}`)}>{children}</h2>;
}
